import React, { useState } from "react";
import { reactIcons } from "../../../utils/icons";

const MintGoldTokens = () => {
  const [form, setForm] = useState({
    goldAmount: "",
    goldPurity: "",
    certificateId: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Minting Tokens with data:", form);
  };

  return (
    <div className="w-full  bg-white shadow-md rounded-xl p-6 font-poppins">
      <div className="pr-10">
        <h2 className="font-poppins font-semibold text-20 leading-5 text-black mb-4">
          Mint Gold Tokens
        </h2>
        <p className="font-poppins font-normal text-16 leading-2 text-[#656565] mb-8">
          Convert Physical gold Bar Into VTSG tokens for circulation inthe
          ecosystem.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {/* Gold Amount */}
          <div>
            <label className="font-poppins font-normal text-16 leading-2 text-[#656565]">
              Gold Amount (oz)
            </label>
            <input
              type="text"
              name="goldAmount"
              value={form.goldAmount}
              onChange={handleChange}
              placeholder="Enter amount in ounces"
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none "
            />
          </div>

          {/* Gold Purity */}
          <div className="relative">
            <label className="font-poppins font-normal text-16 leading-2 text-[#656565] ">
              Gold Purity
            </label>
            <select
              name="goldPurity"
              value={form.goldPurity}
              onChange={handleChange}
              className="w-full mt-1 px-4 py-2 border bg-transparent border-gray-300 rounded-md focus:outline-none "
            >
              <option>24k (99.99%)</option>
              <option>22k (91.6%)</option>
              <option>18k (75%)</option>
              <option>14k (58.5%)</option>
            </select>
            <span className="absolute right-2  top-[50%] text-28">
              {reactIcons.arrowDown}{" "}
            </span>
          </div>

          {/* Certificate ID */}
          <div>
            <label className="font-poppins font-normal text-16 leading-2 text-[#656565]">
              Certificate ID
            </label>
            <input
              type="text"
              name="certificateId"
              value={form.certificateId}
              onChange={handleChange}
              placeholder="Enter certificate ID"
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none "
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="mt-2  bg-primary-100 w-1/2 text-white  py-4 px-4 font-poppins font-medium text-16 leading-4 rounded-md transition"
          >
            Mint Tokens
          </button>
        </form>
      </div>
    </div>
  );
};

export default MintGoldTokens;
